import React, { useEffect, useRef } from "react";
import videojs from "video.js";

export const VideoJs = (props) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const { options, onReady, style, setPlayers } = props;

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement) return;

      const player = (playerRef.current = videojs(videoElement, options, () => {
        setPlayers((prev) => [...prev, player]);
      }));
    }
  }, [options, videoRef]);

  useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player>
      <video
        ref={videoRef}
        className="video-js vjs-big-play-centered vjs-16-9"
        style={style}
      />
    </div>
  );
};

export default VideoJs;
